// Mock data for Adela Merchants website

export const companyInfo = {
  name: "Adela Merchants",
  tagline: "At the Core, of Local Manufacturing",
  email: "Orders@AdelaMerchants.com.au",
  address: "Unit 7, 49/51 Kent Street Cannington, Perth Western Australia",
  businessHours: "Monday to Friday 8am to 4pm",
  walkIns: "Walk-ins by request!",
  website: "www.AdelaMerchants.com.au",
  mapCoordinates: { lat: -32.0167, lng: 115.9333 } // Cannington, Perth
};

export const navItems = [
  { id: "home", label: "Home", href: "#home" },
  { id: "about", label: "About Us", href: "#about" },
  { id: "products", label: "Products", href: "#products" },
  { id: "services", label: "Services", href: "#services" },
  { id: "contact", label: "Contact", href: "#contact" }
];

export const paperCoreProducts = [
  {
    id: 1,
    name: "Standard Paper Cores",
    description: "High-quality paper cores for general industrial use",
    sizes: ["19mm", "25mm", "38mm", "40mm", "76mm", "152mm"],
    applications: ["Label rolls", "Tape winding", "General packaging"]
  },
  {
    id: 2,
    name: "Heavy-Duty Cardboard Cores",
    description: "Thick wall construction for demanding applications",
    sizes: ["3 inch", "Custom diameters"],
    applications: ["Stretch film", "Shrink wrap", "Industrial winding"]
  },
  {
    id: 3,
    name: "Flexographic Printing Cores",
    description: "Precision cores for the printing industry",
    sizes: ["76mm", "152mm", "Custom lengths"],
    applications: ["Flexographic printing", "Label manufacturing"]
  },
  {
    id: 4,
    name: "Concrete Form Tubes",
    description: "Durable cardboard tubes for construction applications",
    sizes: ["Various diameters", "Custom lengths"],
    applications: ["Concrete forming", "Construction pillars", "Engineering projects"]
  },
  {
    id: 5,
    name: "Custom Paper Tubes",
    description: "Made-to-order tubes for specific requirements",
    sizes: ["Any diameter", "Any length", "Any wall thickness"],
    applications: ["Specialty packaging", "Unique industrial needs"]
  }
];

export const printSupplies = [
  {
    id: 1,
    name: "Label Roll Cores",
    description: "Precision cores for label printing applications"
  },
  {
    id: 2,
    name: "Packaging Materials",
    description: "Comprehensive range of packaging solutions"
  },
  {
    id: 3,
    name: "Industrial Winding Supplies",
    description: "Quality supplies for film and foil winding"
  },
  {
    id: 4,
    name: "Print Industry Consumables",
    description: "Essential supplies for print operations"
  },
  {
    id: 5,
    name: "Packing Paper",
    description: "Quality packing and void-fill papers for wrapping, protecting and presenting goods. Available in a range of grades, widths, and roll or sheet formats.",
    image: "/images/products/packing-paper.svg"
  },
  {
    id: 6,
    name: "Self Adhesive Label Stocks",
    description: "Materials such as Polyethylene, Polypropylene, PVC and Vinyl, Machine Coated Paper and Direct Thermal stocks — all with optional adhesives such as Hotmelt, Water-based Acrylic and Solvent, in both Kraft and Standard Glassines.",
    image: "/images/products/label-stocks.svg"
  },
  {
    id: 7,
    name: "Slitting Blades",
    description: "Precision slitting blades suitable for flexographic and rotary-based tooling, as well as plastic forming and extruded materials. Long-lasting edges for clean, accurate cuts.",
    image: "/images/products/slitting-blades.svg"
  }
];

export const services = [
  {
    id: 1,
    title: "Custom Manufacturing",
    description: "Tailored paper cores and tubes to your exact specifications",
    icon: "Settings"
  },
  {
    id: 2,
    title: "Bulk Supply",
    description: "Wholesale quantities for large-scale industrial operations",
    icon: "Package"
  },
  {
    id: 3,
    title: "Fast Turnaround",
    description: "Quick production and delivery across Western Australia",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Quality Assurance",
    description: "Rigorous testing ensures consistent, reliable products",
    icon: "ShieldCheck"
  }
];

export const seoKeywords = {
  primary: [
    "paper tube manufacturer Perth",
    "cardboard core manufacturer Perth",
    "paper core manufacturer Western Australia",
    "cardboard tube manufacturer WA",
    "industrial paper tubes Perth",
    "custom paper tubes Perth"
  ],
  commercial: [
    "paper tubes supplier Perth",
    "cardboard cores supplier WA",
    "wholesale paper tubes Perth",
    "bulk cardboard cores Western Australia"
  ],
  industry: [
    "flexographic printing cores Perth",
    "label roll cores Perth",
    "stretch film cores Perth",
    "concrete form tubes Perth"
  ],
  dimensions: [
    "76mm cardboard cores Perth",
    "25mm cardboard cores Perth",
    "38mm cardboard cores Perth",
    "152mm cardboard cores Perth"
  ]
};

export const aboutContent = {
  headline: "Perth's Trusted Paper Core Manufacturer",
  description: "Adela Merchants is Western Australia's leading supplier of high-quality paper cores, cardboard tubes, and print supplies. Based in Perth, we serve industries across WA with precision-manufactured products that meet the highest standards.",
  values: [
    {
      title: "Australian Made",
      description: "Proudly manufactured in Perth, supporting local industry"
    },
    {
      title: "Quality First",
      description: "Rigorous quality control on every product we deliver"
    },
    {
      title: "Custom Solutions",
      description: "Tailored products to meet your specific requirements"
    }
  ]
};
